import React from 'react';

import { AlgorithmEditor } from '../../algorithm-editor';
import { Algorithm, AlgorithmStep } from '../../../types/algorithm';

interface WorldMapEventProps {
  action?: string;
  taskId?: string;
  shortcutText: string;
  description?: string;
  algorithm?: Algorithm;
  onChange?: (algorithm: Algorithm) => void;
}

export const ToastBulb: React.FC<{
  text: string;
  primaryBulb?: boolean;
  bgColor?: string;
}> = ({ text, primaryBulb, bgColor = '#F8FCFE' }) => {
  return (
    <div
      style={{
        padding: '25px 20px',
        borderRadius: '8px',
        display: 'flex',
        backgroundColor: bgColor,
        alignItems: 'center'
      }}>
      <div
        style={{
          gap: '18px',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center'
        }}>
        <span
          className={`material-symbols-outlined ${primaryBulb ? 'text-primary' : ''}`}>
          emoji_objects
        </span>
        <span
          style={{
            color: '#707070'
          }}>
          {text}
        </span>
      </div>
    </div>
  );
};

const EventAlgorithm = ({
  action,
  algorithm,
  description,
  shortcutText,
  taskId = '',
  onChange
}: WorldMapEventProps) => {
  const handleOnChange = (steps: Array<AlgorithmStep>) => {
    let gameSteps: Algorithm = { ...algorithm };
    gameSteps.steps = steps;

    if (onChange) onChange(gameSteps);
  };

  return (
    <div className={'d-flex flex-column gap-4'}>
      <ToastBulb text={description ?? ''} primaryBulb />

      <AlgorithmEditor
        shortcutText={shortcutText}
        action={action}
        taskId={taskId}
        steps={algorithm?.steps ?? []}
        onChange={handleOnChange}
      />
    </div>
  );
};
export default EventAlgorithm;
